import { c as _c } from "react/compiler-runtime";
import Image, { StaticImageData } from "next/image";
interface Props {
  src: string | StaticImageData;
  alt: string;
  sizes?: string;
}
export default function SeriesStack(t0) {
  const $ = _c(11);
  const {
    src,
    alt,
    sizes
  } = t0;
  let t1;
  if ($[0] !== alt || $[1] !== sizes || $[2] !== src) {
    t1 = <div className="absolute inset-0 flex justify-center items-center"><div className="relative w-[80%] h-full -top-2 md:-top-3 transition-all duration-300 ease-in-out sm:group-hover:top-0 opacity-50"><Image src={src} alt={alt} fill={true} className="object-cover rounded-[20px]" sizes={sizes} /></div></div>;
    $[0] = alt;
    $[1] = sizes;
    $[2] = src;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== alt || $[5] !== sizes || $[6] !== src) {
    t2 = <div className="absolute inset-0 flex justify-center items-center"><div className="relative w-[90%] h-full -top-1 md:-top-1.5 transition-all duration-300 ease-in-out sm:group-hover:top-0 opacity-50"><Image src={src} alt={alt} fill={true} className="object-cover rounded-[20px]" sizes={sizes} /></div></div>;
    $[4] = alt;
    $[5] = sizes;
    $[6] = src;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="absolute inset-0 z-0 pointer-events-none">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}